import { Icon } from "@chakra-ui/react"
import SvgRocket from "@public/svg/misc/rocket.svg"
import { AnimatePresence } from "framer-motion"

import { FramerBox } from "./FramerBox"

export default function Rocket({ locale }: { locale: string | undefined }) {
  return (
    <AnimatePresence>
      <FramerBox
        key={"rocket"}
        initial={{
          opacity: 0,
        }}
        whileInView={{
          opacity: 1,
          x: 0,
          y: 0,
        }}
        animate={{
          x: locale === "ar" ? 600 : -600,
          y: 400,
          rotate: locale === "ar" ? 270 : 0,
        }}
        exit={{ opacity: 0, x: 0, y: 400 }}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        transition={{
          duration: 0.5,
          ease: "easeInOut",
        }}
        display={{ base: "none", md: "block" }}
      >
        <Icon
          as={SvgRocket}
          color={"brand.primary"}
          w={{ base: 64, md: 96 }}
          h={{ base: 64, md: 96 }}
        />
      </FramerBox>
    </AnimatePresence>
  )
}
